import { Upload } from "lucide-react";
import { Link } from "react-router-dom";
import ActivityFeed from "./ActivityFeed";
import AdminControlNavigation from "./AdminControlNavigation";
import DocumentLibraryManager from "./DocumentLibraryManager";

function RequestList({ requests, onDecision }) {
  if (!requests.length) {
    return <div className="empty-state" data-testid="admin-requests-empty-state">No access requests yet.</div>;
  }

  return (
    <div className="request-list" data-testid="admin-access-requests">
      {requests.map((request) => (
        <article key={request.request_id} data-testid={`admin-request-${request.request_id}`}>
          <div>
            <span>{request.classification}</span>
            <h3>{request.full_name}</h3>
            <p>{request.company || "Independent"} · {request.email}</p>
          </div>
          <div className="request-actions">
            <span className={`status-pill ${request.status === "approved" ? "status-pill--approved" : ""}`}>{request.status}</span>
            {request.status === "pending" && <>
              <button className="button button--red" onClick={() => onDecision(request.request_id, "approved")} data-testid={`approve-request-${request.request_id}`}>Approve</button>
              <button className="button button--ghost" onClick={() => onDecision(request.request_id, "declined")} data-testid={`decline-request-${request.request_id}`}>Decline</button>
            </>}
          </div>
        </article>
      ))}
    </div>
  );
}

export default function AdminWorkspace({ overview, requests, activity, documents, uploadState, onDecision, onUpload, onDeleteDocument, deletingDocument, onExportActivity, onExportLeads, onResend, onRefresh, resendingEntity, isRefreshing }) {
  return (
    <main className="admin-page" data-testid="admin-page">
      <section className="portal-header">
        <div>
          <span className="eyebrow">Administrator workspace</span>
          <h1>GAMEDAY CONTROL ROOM</h1>
        </div>
        <div className="portal-controls" data-testid="admin-workspace-navigation">
          <Link className="button button--outline" to="/investor-portal" data-testid="admin-portal-link">Investor portal</Link>
        </div>
      </section>
      <AdminControlNavigation active="dashboard" />
      <section className="metrics-grid" data-testid="admin-metrics">
        <article><span>Pending access</span><strong>{overview.pending_access_requests}</strong></article>
        <article><span>New leads</span><strong>{overview.new_leads}</strong></article>
        <article><span>Published documents</span><strong>{overview.documents}</strong></article>
      </section>
      <ActivityFeed items={activity} onExportActivity={onExportActivity} onExportLeads={onExportLeads} onResend={onResend} onRefresh={onRefresh} resendingEntity={resendingEntity} isRefreshing={isRefreshing} />
      <DocumentLibraryManager documents={documents} onDelete={onDeleteDocument} deletingDocument={deletingDocument} />
      <section className="admin-section">
        <div><span className="eyebrow">Access review</span><h2>INVESTOR REQUESTS</h2></div>
        <RequestList requests={requests} onDecision={onDecision} />
      </section>
      <section className="admin-section">
        <div><span className="eyebrow">Confidential library</span><h2>UPLOAD A DOCUMENT</h2></div>
        <form className="document-upload-form" data-testid="document-upload-form" onSubmit={onUpload}>
          <label>Document title<input name="title" data-testid="document-title-input" required /></label>
          <label>Category<input name="category" data-testid="document-category-input" required /></label>
          <label>File<input name="file" type="file" data-testid="document-file-input" required /></label>
          <button className="button button--red" disabled={uploadState === "loading"} data-testid="document-upload-button">
            <Upload size={16} />
            {uploadState === "loading" ? "Uploading…" : "Upload document"}
          </button>
        </form>
        {uploadState === "success" && <p className="upload-message" data-testid="document-upload-success">Document uploaded to the controlled library.</p>}
        {uploadState === "error" && <p className="form-error" data-testid="document-upload-error">Upload could not be completed. Confirm the file type and try again.</p>}
      </section>
    </main>
  );
}